//default
import React from "react";
//css
import "./modal.scss";

const Modal = ({ params, accion }) => {
	return (
		<div className="contenedor_modal">
			(
			<div className="modal">
				<img src={params.icono} className="icono-modal" />
				<p className="parrafo-modalAdvertencias">{params.resultado}</p>
				<div className="linea">
					<button autoFocus onClick={() => accion()}>
						Aceptar
					</button>
				</div>
			</div>
		</div>
	);
};

export default Modal;
